module.exports = __webpack_public_path__ + "img/logo_fxwallet.b0bb9b85.png";